import API_GATEWAY_URL from '../config';

const auth_url_prefix = 'https://login.microsoftonline.com/b3a10deb-b783-4098-b047-656b2a9d1453/oauth2/v2.0/authorize';
const clientId = 'c9698d60-ea0a-4c45-8bf0-d5017d999c4a';
const parsedUrl = new URL(window.location.href);
const redirect_url = `${parsedUrl.protocol}//${parsedUrl.host}`;
const auth_url = `${auth_url_prefix}?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirect_url)}&scope=openid profile email`;
const generate_jwt_token_url = `${API_GATEWAY_URL}/token/generate?redirect_url=${encodeURIComponent(redirect_url)}`;
const external_login_url = `${API_GATEWAY_URL}/token/login`;

// Check for existing token or OAuth code on page load
export const checkExistingAuth = (setUser, setInitializing) => {
    const generate_jwt_token = (token, tokenType) => {
        fetch(generate_jwt_token_url, {
            method: 'GET',
            headers: {
                'X-Token-Type': tokenType,
                'Authorization': token,
            }
        })
            .then(response => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    throw new Error('Error: ' + response.statusText);
                }
            })
            .then(data => {
                setUser(data);
                localStorage.setItem('palm_care_token', data.jwt_token);
                localStorage.setItem('palm_care_email', data.email);
                localStorage.setItem('palm_care_group', data.group);

                // Clean up the URL if we came from an OAuth redirect
                if (tokenType === 'Code') {
                    window.history.replaceState({}, document.title, window.location.pathname);
                }
                setInitializing(false);
            })
            .catch(error => {
                console.error('Auth Error:', error);
                localStorage.removeItem('palm_care_token');
                
                // Also clean up the URL on failure so the user isn't permanently stuck
                // trying to reuse an expired code every time they refresh
                if (tokenType === 'Code') {
                    window.history.replaceState({}, document.title, window.location.pathname);
                }
                setInitializing(false);
            });
    }

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    if (code) {
        generate_jwt_token(code, 'Code');
    } else {
        const jwt_token = localStorage.getItem('palm_care_token');
        if (jwt_token) {
            generate_jwt_token(jwt_token, 'JWT');
        } else {
            setInitializing(false);
        }
    }
};

// Trigger Entra ID OAuth Redirect
export const handleInternalLogin = () => {
    window.location.href = auth_url;
};

// Handle External Email/Password Login
export const handleExternalLogin = async (email, password, setUser) => {
    try {
        const response = await fetch(external_login_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password })
        });

        const data = await response.json();

        if (response.status === 200) {
            setUser(data);
            localStorage.setItem('palm_care_token', data.jwt_token);
            localStorage.setItem('palm_care_email', data.email);
            localStorage.setItem('palm_care_group', data.group);
            return { success: true };
        } else {
            return { success: false, error: data.message || data.error || 'Authentication failed' };
        }
    } catch (error) {
        console.error('External Login Error:', error);
        return { success: false, error: 'Failed to connect to authentication server' };
    }
};